export default {
      id: "fish-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#fish",
      toString: function () {
        return this.url;
      }
    }